import { render, staticRenderFns } from "./InboxHeader.vue?vue&type=template&id=1d7dcf6e&"
import script from "./InboxHeader.vue?vue&type=script&lang=js&"
export * from "./InboxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports